const ACTION_TYPES = {
    SET_RWD_BASKET: 'SET_RWD_BASKET',
    SET_MAIN_BASKET_TYPE: 'SET_MAIN_BASKET_TYPE',
    SET_ROOT_BASKET_TYPE: 'SET_ROOT_BASKET_TYPE',

    // TODO (INFL-????) This is the list of legacy  actions being used in new basket
    // We must make sure they continue to be fired after old basket is deprcated
    // Legacy using
    UPDATE_BASKET: 'UPDATE_BASKET',

    // Legacy remove???
    SET_BASKET_TYPE: 'SET_BASKET_TYPE'
};

const { calculateRootBasketType } = require('utils/RwdBasket');

const initialState = {
    basket: null,
    isInitialized: false,
    currentRootBasketType: null,
    currentMainBasketType: null,
    shouldScrollToTop: false,

    // Legacy
    currentBasketType: null
};

const reducer = function (state = initialState, action) {
    // Backwards compatibility for legacy actions
    const payload = action.payload || action;

    switch (action.type) {
        case ACTION_TYPES.SET_RWD_BASKET: {
            return {
                ...state,
                isInitialized: true
            };
        }

        case ACTION_TYPES.UPDATE_BASKET: {
            const { basket } = payload;

            const newPageLoad = state.currentMainBasketType == null && state.currentRootBasketType == null;

            return {
                ...state,
                basket,
                ...(newPageLoad && { ...calculateRootBasketType(basket) }),
                shouldScrollToTop: newPageLoad
            };
        }

        case ACTION_TYPES.SET_ROOT_BASKET_TYPE: {
            const { currentRootBasketType } = payload;

            return {
                ...state,
                currentRootBasketType,
                shouldScrollToTop: true
            };
        }

        // For buttons/links on PRE_BASKET
        // For SwitchBasket on MAIN_BASKET
        case ACTION_TYPES.SET_MAIN_BASKET_TYPE: {
            const { currentMainBasketType } = payload;

            return {
                ...state,
                currentMainBasketType,
                shouldScrollToTop: true
            };
        }

        // KEEP this as legacy basket type
        // try not to write new code that uses this
        // use this to monitor existing dispatches
        case ACTION_TYPES.SET_BASKET_TYPE: {
            const { currentBasketType } = payload;

            return {
                ...state,
                currentBasketType
            };
        }

        default:
            return state;
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

module.exports = reducer;
